<template>
  <div>
    <img src="../../assets/icon-star.svg" alt="" />
  </div>
</template>

<style lang="scss" scoped>
div {
  align-items: center;
  background-color: hsl(213, 19%, 18%);
  border-radius: 50%;
  display: flex;
  height: 50px;
  justify-content: center;
  width: 50px;
}
</style>
